<template>
  <div class="footer_wrap">
    <div id="footer_area" class="clear">
      <!--======================
      サイトマップ
      ======================-->
      <div class="sitemapTtl" id="tog">
        <h2><span>サイトマップ</span></h2>
      </div>
      <div class="footSitemap">
        <h2><a href="/jsp/ownersclub/index.jsp">ミサワオーナーズクラブ</a></h2>
        <div class="sitemapWrap">
          <div class="sitemapBox">
            <h3 class="ftico01"><a href="/jsp/ownersclub/my/maintenanceinfo/" class="need-login">Myページ</a></h3>
            <ul class="clearfix">
              <li><a href="/jsp/ownersclub/my/maintenanceinfo/" class="need-login">建物情報</a></li>
              <li><a v-if="isVisibleMPoint" href="/jsp/ownersclub/my/pointinfo/" class="need-login">ミサワポイント</a></li>
              <li><a v-if="energyPage == 'hgw' && isVisibleLinkgates"     href="/jsp/ownersclub/my/hgw/">LinkGates</a></li>
              <li><a v-if="energyPage == 'enecoco'" href="/jsp/ownersclub/my/enecoco2/">enecoco</a></li>
              <li><a v-if="energyPage == 'hgwinfo' && isVisibleLinkgates" href="/jsp/ownersclub/my/hgwinfo/">LinkGates</a></li>
              <li><a v-if="energyPage == null && isVisibleLinkgates"      href="/jsp/ownersclub/my/hgwinfo/" class="need-login">LinkGates</a></li>
              <li><a href="/jsp/ownersclub/my/bousaiinfo/" class="need-login">防災info</a></li>
              <li><a href="/jsp/ownersclub/my/subscription/" class="need-login">サブスクリプション</a></li>
            </ul>
          </div>
          <div class="sitemapBox">
            <h3 class="ftico07"><a href="https://www.misawa.co.jp/ownersclub/lifesupport/" class="need-login">優待・ショッピング</a></h3>
            <ul class="clearfix">
              <li><a href="https://www.misawa.co.jp/ownersclub/lifesupport/" class="need-login">ライフサポート・サービス</a></li>
              <li><a href="https://life.misawa.co.jp/link.php/" target="_blank" class="need-login">らいさぽWeb</a></li>
              <li><a href="https://www.misawa.co.jp/ownersclub/lifesupport/uchinokoto.html" class="need-login">ウチノコトサービス</a></li>
            </ul>
          </div>
          <div class="sitemapBox">
            <h3 class="ftico02"><a href="/jsp/ownersclub/maintenance/main/">お手入れ・メンテナンス</a></h3>
            <ul class="clearfix">
              <li><a href="/jsp/ownersclub/maintenance/main/">部位別お手入れ・<br>メンテナンス</a></li>
              <li><a :href="`${mypageRootPath}/../maintenance/movie/`">お手入れ動画</a>
              <li v-if="!isMansionMember"><a href="/jsp/ownersclub/maintenance/checklist/">年1回のチェックリスト</a></li>
              <li v-if="!isMansionMember"><a href="/jsp/ownersclub/maintenance/warranty/">保証制度・<br>アフターサービス</a></li>
            </ul>
          </div>
          <div class="sitemapBox">
            <h3 class="ftico03"><a :href="`${mypageRootPath}/../column/`" class="need-login">くらしのコラム</a></h3>
            <ul class="clearfix">
              <li><a :href="`${mypageRootPath}/../column/?category=life`" class="need-login">生活</a></li>
              <li><a :href="`${mypageRootPath}/../column/?category=family`" class="need-login"> 家族</a></li>
              <li><a :href="`${mypageRootPath}/../column/?category=health`" class="need-login">健康</a></li>
              <li><a :href="`${mypageRootPath}/../column/?category=meal`" class="need-login">食事</a></li>
            </ul>
          </div>
          <div class="sitemapBox">
            <h3 class="ftico04"><a href="/jsp/ownersclub/reform/">リフォームしたい</a></h3>
            <ul class="clearfix">
              <li><a href="/jsp/ownersclub/reform/#jirei">リフォーム事例</a></li>
              <li><a href="/jsp/ownersclub/reform/#academy">実践リフォーム塾</a></li>
              <li><a href="/jsp/ownersclub/reform/#recommend">オススメリフォーム</a></li>
              <li><a href="https://www.misawa.co.jp/ownersclub/senior/">理想のセカンドライフ</a>
            </ul>
          </div>
          <div class="sitemapBox">
            <h3 class="ftico05"><a href="https://www.misawa.co.jp/ownersclub/fudosan_support/index.html">売りたい・貸したい</a></h3>
            <ul class="clearfix">
	      <li><a href="https://www.misawa.co.jp/ownersclub/fudosan_support/sell.html#sumstock">適正な評価で自宅を売りたい方</a>
	      <li><a href="https://www.misawa.co.jp/ownersclub/fudosan_support/sell.html#homever">早く確実に自宅を売りたい方</a>
	      <li><a href="https://www.misawa.co.jp/ownersclub/fudosan_support/rent.html">自宅を手放さず貨したい方</a>
	      <li><a href="https://www.misawa.co.jp/ownersclub/sumikae/">住み替え</a>
            </ul>
          </div>
          <!-- sitemapWrap --></div>
      </div>

        <!-- PC Footer -->
        <div class="pc_footer">
          <div id="foot_info">
            <ul>
              <li id="foot_info01">
                <a href="https://www.misawa.co.jp/corporate/about/pltgroup/">
                  <img src="https://www.misawa.co.jp/gbm/images/logo_plt.svg" width="300" height="24.25" alt="PLT" class="gb_plt">
                </a>
                <p>ミサワホームは、未来志向のまちづくりと豊かな地域社会の実現を目指す<br>プライム ライフ テクノロジーズ株式会社(PLT)のグループ会社です。</p>
              </li>
              <li id="foot_info02">
                <img src="https://www.misawa.co.jp/common_d/image/foot_info02.png" width="269" height="74" alt="住まいを通じて生涯のおつきあい［ミサワホーム］">
              </li>
            </ul>
          </div>

          <div id="footer_menu" class="clearfix">
            <ul id="footer_menu2">
              <li>＞ <a href="http://www.misawa.co.jp/legal/site.html">このサイトについて</a></li>
              <li>＞ <a href="/jsp/ownersclub/taikai/">退会について</a></li>
              <li>＞ <a href="https://www.misawa.co.jp/legal/security.html">情報セキュリティ基本方針</a></li>
              <li>＞ <a href="http://www.misawa.co.jp/legal/privacy.html">プライバシーポリシー</a></li>
            </ul>
          </div>
        </div>

      <!-- SP Footer -->
      <div class="sp_footer">
        <div class="footer_sp">
          <div class="ft_wrap">
            <div class="wrap_bg">
              <p class="ftr_misawa">
                  <img src="https://www.misawa.co.jp/gbm/images/logo_misawa_blue.svg" alt="MISAWA ミサワホーム">
              </p>
              <p class="ftr_plt">
                <a href="https://www.misawa.co.jp/corporate/about/pltgroup/">
                  <img src="https://www.misawa.co.jp/gbm/images/logo_plt.svg" alt="未来をまちづくるPLT Group">
                </a>
              </p>
            </div>
            <div class="footer-nav">
              <ul class="footer-menu">
                <li>＞ <a href="http://www.misawa.co.jp/legal/site.html">このサイトについて</a></li>
                <li>＞ <a href="/jsp/ownersclub/taikai/">退会について</a></li>
                <li>＞ <a href="https://www.misawa.co.jp/legal/security.html">情報セキュリティ基本方針</a></li>
                <li>＞ <a href="http://www.misawa.co.jp/legal/privacy.html">プライバシーポリシー</a></li>
              </ul>
            </div>
            <div class="copyright-wrap">
              <p class="copyright">Copyright &copy; MISAWA HOMES CO.,LTD. All Rights Reserved.</p>
            </div>
          </div>
        </div>
      </div>

      <!--======================
      // foot info
      ======================-->

      <div id="footToTop">
        <div class="toTop">
          <p>
          <a href="#body_box">ページ上部へ<span class="ico"></span></a>
          </p>
        </div>
      </div>

    </div>
    <div class="bgWhite">
      <p id="footer_copyright">Copyright &copy; MISAWA HOMES CO.,LTD. All Rights Reserved.</p>
    </div>
    <div class="goTop">
      <a href="#head_area">
        <img :src="`${mypageRootPath}/common/image/btn_pagetop.png`" width="35" height="35">
      </a>
    </div>
  </div>

</template>

<script>
import Common from './Common.js'
import gotop from "../js/moc_footer_gotop.js"

export default {
  name: 'moc-footer',

  mixins: [ Common ],

  mounted: function() {
    gotop();
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MocFooter.vue